/**
 * bc-blog-community — Simple blog carousel (no tabs)
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bc-blog-community]').forEach(initCarousel);
  });

  function initCarousel(root) {
    var track = root.querySelector('.bc-blog-community__track');
    var dotsWrap = root.querySelector('.bc-blog-community__dots');
    var prevBtn = root.querySelector('[data-arrow="prev"]');
    var nextBtn = root.querySelector('[data-arrow="next"]');

    if (!track) return;

    var cards = track.querySelectorAll('.bc-blog-community__card');
    if (!cards.length) return;

    var currentPage = 0;

    function getVisibleCount() {
      var w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 989) return 2;
      return 3;
    }

    function getTotalPages() {
      return Math.max(1, Math.ceil(cards.length / getVisibleCount()));
    }

    function buildDots() {
      if (!dotsWrap) return;
      var totalPages = getTotalPages();
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalPages; i++) {
        var dot = document.createElement('button');
        dot.className = 'bc-blog-community__dot' + (i === currentPage ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.setAttribute('data-page', i);
        dot.addEventListener('click', function () {
          goToPage(parseInt(this.getAttribute('data-page')));
        });
        dotsWrap.appendChild(dot);
      }
    }

    function goToPage(page) {
      var totalPages = getTotalPages();
      if (page < 0) page = totalPages - 1;
      if (page >= totalPages) page = 0;
      currentPage = page;

      var gap = parseInt(getComputedStyle(track).gap) || 32;
      var cardWidth = cards[0].offsetWidth + gap;
      track.scrollTo({
        left: currentPage * getVisibleCount() * cardWidth,
        behavior: 'smooth'
      });

      updateDots();
    }

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('.bc-blog-community__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === currentPage);
      });
    }

    /* Scroll sync */
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var gap = parseInt(getComputedStyle(track).gap) || 32;
        var cardWidth = cards[0].offsetWidth + gap;
        var scrollPage = Math.round(track.scrollLeft / (cardWidth * getVisibleCount()));
        scrollPage = Math.max(0, Math.min(scrollPage, getTotalPages() - 1));
        if (scrollPage !== currentPage) {
          currentPage = scrollPage;
          updateDots();
        }
      }, 100);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goToPage(currentPage - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goToPage(currentPage + 1); });
    }

    /* Rebuild dots only when the number of visible cards actually changes.
       Mobile browsers fire `resize` on vertical scroll (address bar show/hide),
       which must not reset horizontal scroll position. */
    var resizeTimer;
    var lastVisibleCount = getVisibleCount();
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var visibleCount = getVisibleCount();
        if (visibleCount === lastVisibleCount) return;
        lastVisibleCount = visibleCount;
        currentPage = 0;
        buildDots();
        track.scrollTo({ left: 0 });
      }, 200);
    });

    buildDots();
  }
})();
